import { FC } from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

import { useAppSelector } from 'libraries/redux'
import { FacebookIcon, InstagramIcon, TelegramIcon, ViberIcon } from 'assets/icons'
import { CategoriesSelectors } from 'store/category/selectors'

import styles from './Footer.module.scss'
import { WishlistSelectors } from 'store/wishlist/selectors'

const Footer: FC = () => {
  const { data: storeInfo } = useAppSelector(CategoriesSelectors.storeInfo)
  const { data: informationList } = useAppSelector(WishlistSelectors.informationList)

  const URLfiltering = (url: string, name: string) => {
    if (!url) return ''

    const isFullUrl = url.startsWith('http') || url.startsWith('viber://')

    if (isFullUrl) return url

    switch (name.toLowerCase()) {
      case 'facebook':
        return `https://facebook.com/${url}`
      case 'instagram':
        return `https://instagram.com/${url}`
      case 'telegram':
        return `https://t.me/${url}`
      case 'viber':
        return `viber://add?number=${url}`
      default:
        return url
    }
  }

  const socialUrls = [
    { Icon: FacebookIcon, url: URLfiltering(storeInfo.facebook_url, 'facebook') },
    { Icon: InstagramIcon, url: URLfiltering(storeInfo.instagram_url, 'instagram') },
    { Icon: TelegramIcon, url: URLfiltering(storeInfo.telegram_url, 'telegram') },
    { Icon: ViberIcon, url: URLfiltering(storeInfo.viber_url, 'viber') },
  ]

  const hasSocialUrls = socialUrls?.some(({ url }) => url !== null)
  const handleSocialClick = () => {
    if (storeInfo?.fb_pixel_id) {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Contact')
      }
    }
  }
  const renderMenuSocList = socialUrls?.map(({ url, Icon }, index) => {
    if (url === null) return null

    return (
      <a
        className={styles.wrapper_container__menu_list_items_name}
        href={url}
        key={index}
        target='_blank'
        onClick={handleSocialClick}
      >
        <Icon />
      </a>
    )
  })

  const renderInformationStates = informationList?.map(({ translation, id }: any) => (
    <Link className={styles.wrapper_footer__link_item} key={id} to={`/information/${id}`} onClick={handleSocialClick}>
      {translation.title}
    </Link>
  ))

  return (
    <footer className={styles.wrapper}>
      <div className={classNames(styles.wrapper_container, 'container')}>
        <div className={styles.logo}>
          <p>{storeInfo?.name}</p>
          <a href={`tel:${storeInfo?.phone?.original}`} className={styles.logo_phone} onClick={handleSocialClick}>
            {storeInfo?.phone?.international}
          </a>
        </div>

        <div className={styles.wrapper_container__menu}>
          <div className={styles.wrapper_container__menu_list}>
            <p className={styles.wrapper_container__menu_list_title}>Юридична інформація</p>
            <div
              className={styles.wrapper_container__menu_list_items}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              {renderInformationStates}
            </div>
          </div>
        </div>
      </div>

      <hr className={styles.wrapper__hr} />

      <div className={classNames(styles.wrapper_footer, 'container')}>
        <p>© 2025 {storeInfo?.name}. Усі права захищено.</p>

        <div className={styles.wrapper_footer__link}>
          {hasSocialUrls && (
            <div className={styles.wrapper_container__menu_list}>
              <p className={styles.wrapper_container__menu_list_title}></p>
              <div
                className={styles.wrapper_container__menu_list_items}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {renderMenuSocList}
              </div>
            </div>
          )}
        </div>
      </div>
    </footer>
  )
}

export default Footer
